import styled from "styled-components";

export const AgreementContainer = styled.div`
  .agreementTextWrapper {
    display: flex;
    align-items: start;
    margin-bottom: 32px;

    img {
      margin-right: 10px;
      width: 30px;
    }
  }

  a {
    color: #e6000f;
  }

  .agreementWrapper {
    text-align: justify;

    @media (max-width: 800px) {
      padding: 0 10px;
      text-align: start;
    }
  }

  .infoText {
    padding: 30px;
    background-color: rgba(20, 147, 108, 0.1);
    margin-bottom: 50px;
    display: flex;
    align-items: center;

    .txt {
      margin-left: 30px;
    }
  }
`;

export const RedATag = styled.a`
  display: inline-block;
  color: rgb(230, 0, 15);
`;

export const AgreementToggle = styled.button`
  width: 21px;
  height: 12px;
  background: ${(props) => (props.isAgreed ? "green" : "#9ca3af")};
  border-radius: 12.8px;
  position: relative;
  margin-top: 4px;
  border: none;
  cursor: pointer;

  :after {
    content: "";
    position: absolute;
    width: 9px;
    height: 9px;
    background: #fff;
    border-radius: 50%;
    top: 50%;
    left: 1.5px;
    transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    transform: translateY(-50%)
      ${(props) => props.isAgreed && "translateX(7.5px)"};
  }
`;

export const DocumentLink = styled.a`
  margin-left: 8px; /* ml-2 */
  margin-right: 8px; /* mr-2 */
  color: #e6000f;
  opacity: 1;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  text-decoration: none;

  }
`;

export const PurposeConsentWrapper = styled.div`
  display: flex;
  gap: 10px;

  div {
    color: #333842;
    display: flex;
    flex-direction: column;
    gap: 4px;
    width: fit-content;

    h6 {
      font-size: 14px;
      font-weight: bold;
      line-height: 19.6px;
      margin: 0;
    }

    p {
      font-size: 12px;
      line-height: 16.8px;
      margin: 0;
    }
  }
`;
